import styled from 'styled-components';

export const HomeContainer = styled.div`
  padding: 0 0 2rem 0;
`;

export const ContentSection = styled.section`
  text-align: center;
  margin: 4rem 0;
`;

export const Title = styled.h1`
  font-size: 3rem;
  margin-bottom: 1rem;
  color: white;
`;

export const Subtitle = styled.p`
  font-size: 1.2rem;
  color: white;
  max-width: 600px;
  margin: 0 auto;
`;
